import { koComponent } from "../../ko-utils";

class CompanySsoView {
  constructor(params, parentPage) {
    this.parentPage = parentPage;

    this.ssoIdentifier = this.parentPage.getServerSideData("ssoIdentifier");

    this.load();
  }

  load() {}
}

export default koComponent("company-sso-view", CompanySsoView);
